import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Container, Header, Segment, Grid, Card, Message, Divider, List, Button, Icon } from 'semantic-ui-react';
import '../Playbook.css';

class ExamplesAndTemplates extends Component {
    handleDownload = () => {
        const link = document.createElement('a');
        link.href = '/downloads/proposal-template.docx';
        link.download = 'proposal-template.docx';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    render() {
        return (
            <Container fluid className="playbook-container">
                <h1 className="ui icon center aligned header playbook-branded-header" style={{fontFamily: 'Montserrat', textTransform: 'uppercase', color: 'rgb(35, 37, 58)', fontWeight: 600, fontSize: '38px', marginBottom: '-9px'}}>
                    <i aria-hidden="true" className="icon">
                        <img src="/static/media/logo-icon.7bb8994723bbdcd674f1.png" alt="logo-icon" style={{height: '68px', marginBottom: '-15px'}} />
                    </i>
                    Closing
                </h1>
                <div className="ui divider"></div>

                <Grid stackable>
                    <Grid.Row>
                        <Grid.Column width={16}>
                            <Segment className="playbook-content">
                                <Header as="h2" className="section-header">Proposal Template</Header>
                                
                                <p>
                                    Here is a jumping-off point you can use to create your proposal. Download it and use 
                                    the other examples in this module to craft your own proposal.
                                </p>

                                <Card fluid color="blue">
                                    <Card.Content>
                                        <Card.Header>
                                            <Icon name="download" />
                                            Proposal Template
                                        </Card.Header>
                                        <Card.Description>
                                            <Button primary icon labelPosition="left" onClick={this.handleDownload}>
                                                <Icon name="download" />
                                                Proposal Template
                                            </Button>
                                        </Card.Description>
                                    </Card.Content>
                                </Card>

                                <Divider />

                                <Header as="h2" className="section-header">Sending the Proposal</Header>
                                
                                <p>
                                    The thing you need to realize is that when you create a proposal, knowing when to 
                                    follow up can be difficult. We don't like to feel like we are chasing, but we want 
                                    to know the prospect got it. So how do we do that? We tell them when we will follow 
                                    up when we send the proposal. See the example of the actual email below.
                                </p>

                                <p>
                                    This sets the stage for the follow-up. See the "Sales Activity" Module for 
                                    additional information on how we recommend following up.
                                </p>

                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>
                                            <Icon name="mail" />
                                            Example Proposal Email
                                        </Card.Header>
                                        <Card.Description>
                                            <Segment basic style={{backgroundColor: '#f8f9fa', border: '1px solid #dee2e6', padding: '15px', fontFamily: 'monospace'}}>
                                                ---- Begin Example Email ----<br/><br/>
                                                
                                                Tom / Sarah – Great meeting you guys the other day. I love what you all are doing 
                                                and am glad you guys found the ABC Corp crowd. Per our conversation, I have attached 
                                                the proposal for a message-creation and training engagement. Here are the high points:<br/><br/>
                                                
                                                •	3-month engagement – 1st 4-6 weeks building out the messaging / 2nd 6-8 weeks 
                                                training and applying concepts in customer settings<br/>
                                                •	Train a team of 4-6<br/>
                                                •	Meet formally once a week with impromptu meetings throughout the week<br/>
                                                •	You all get all of our processes to continue post Multiply if you choose<br/>
                                                •	Price of $XX,XXX<br/>
                                                •	Start date some time after June 15 pending schedules.<br/><br/>
                                                
                                                I definitely see how this process can help as you merge companies and differentiate 
                                                the staffing and solutioning capabilities. Feel free to reach out with questions, 
                                                or I'll follow up in the next couple days if I don't hear back from you.<br/><br/>
                                                
                                                Thanks and I look forward to our next discussion.<br/><br/>
                                                
                                                Ryan<br/><br/>
                                                
                                                -----End Example Email -----
                                            </Segment>
                                        </Card.Description>
                                    </Card.Content>
                                </Card>

                                <p>When we send a proposal we want to:</p>

                                <List bulleted>
                                    <List.Item><strong>Be clear and concise</strong></List.Item>
                                    <List.Item><strong>Boil the contents of the proposal down into a few bullet points.</strong></List.Item>
                                    <List.Item><strong>Include a start date</strong></List.Item>
                                    <List.Item><strong>Set expectations on when YOU will follow up.</strong></List.Item>
                                </List>

                                <p>
                                    Expect the prospect to get the proposal email on his/her phone. The bullets allow 
                                    them to take a quick look and get the gist; then they can then go back and review later. 
                                    When you send your proposal, give the prospect time to read it, process it, and react. 
                                    Tell the prospect to contact you if he or she has any questions, comments, etc. 
                                    Otherwise you will check back in a week. If I send a proposal on a Wednesday, then I 
                                    typically say: "Take a look and text, call, or email if you have any questions or want 
                                    to discuss further. Otherwise, I will follow up with you next Wednesday."
                                </p>

                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Container>
        );
    }
}

export default observer(ExamplesAndTemplates);